import { useButton, AriaButtonProps } from '@react-aria/button';
import { useRef } from 'react';

export function CalendarNavigationButton(props: AriaButtonProps<'button'>) {
  const ref = useRef<HTMLButtonElement | null>(null);
  const { buttonProps } = useButton(props, ref);
  return (
    <button
      {...buttonProps}
      ref={ref}
      className="text-token-gray-1600 bg-token-alphalight-200 rounded-[9px] h-7.5 w-7.5 flex justify-center items-center shadow-25"
    >
      {props.children}
    </button>
  );
}
